import hasuraHeaders from './hasuraHeaders'
import collectionDefinitions from './mapDefinitions/collections'
import creditLinesDefinitions from './mapDefinitions/creditLines'
import invoiceDefinitions from './mapDefinitions/invoices'
import paymentDefinitions from './mapDefinitions/payments'

const resources = [
  invoiceDefinitions,
  creditLinesDefinitions,
  collectionDefinitions,
  paymentDefinitions,
]

const axios = {
  post: () => {},
}

const hasuraGraphQLUrl = process.env.REACT_APP_HASURA_URL

const getResourceByAppResourceName = (appResourceName) => {
  const result = resources.find(
    (resource) => resource.appResourceName === appResourceName
  )

  return result
}

const getHasuraField = (resource, appField) => {
  const result = resource.fields?.find((field) => field.app === appField)

  if (result) {
    return result.hasura
  }

  return appField
}

const getAppField = (resource, hasuraField) => {
  const result = resource.fields?.find((field) => field.hasura === hasuraField)

  if (result) {
    return result.app
  }

  return hasuraField
}

const getAppRecord = (appResource, hasuraRecord) => {
  const appRecord = Object.keys(hasuraRecord).reduce(
    (appRecord, hasuraField) => ({
      ...appRecord,
      [getAppField(appResource, hasuraField)]: hasuraRecord[hasuraField],
    }),
    {}
  )

  return appRecord
}

const getList = async (dataProviderBuilder, resource, type, appParams) => {
  console.log(dataProviderBuilder)
  console.log(resource)
  console.log(type)
  console.log(appParams)
  const hasuraParams = {
    ...appParams,
    sort: {
      ...appParams.sort,
      field: getHasuraField(resource, appParams?.sort?.field),
    },
  }

  const response = await dataProviderBuilder(
    type,
    resource.hasuraResourceName,
    hasuraParams
  )

  return {
    ...response,
    data: response.data.map((item) => getAppRecord(resource, item)),
  }
}

const getOne = async (dataProviderBuilder, resource, type, appParams) => {
  const hasuraParams = Object.keys(appParams).reduce((filter, field) => {
    return {
      ...filter,
      [getHasuraField(resource, field)]: appParams[field],
    }
  }, {})

  const response = await dataProviderBuilder(
    type,
    resource.hasuraResourceName,
    hasuraParams
  )

  return {
    ...response,
    data: getAppRecord(resource, response?.data),
  }
}

export const sendToHasura = async (request) => {
  const result = await axios.post(hasuraGraphQLUrl, request.body, {
    headers: hasuraHeaders(),
  })

  if (process.env.REACT_APP_CUSTOM_QUERIES) {
    console.log(JSON.stringify(result?.data?.data))
    console.log(request.command)
    console.log(JSON.stringify(result?.data?.data[request.command]))
  }

  return result?.data?.data[request.command]
}

const dataProvider = (dataProviderBuilder) => {
  return async (type, appResourceName, appParams) => {
    const resource = getResourceByAppResourceName(appResourceName)
    console.log(appResourceName)
    console.log(resource)
    console.log(type)
    console.log(appParams)

    if (process.env.REACT_APP_CUSTOM_QUERIES) {
      console.log(`dataProvider type ${type}`)
      console.log(`dataProvider appResourceName ${appResourceName}`)
      console.log(`dataProvider appParams ${JSON.stringify(appParams)}`)
    }

    if (resource?.buildRequest && resource.buildRequest[type]) {
      return await sendToHasura(resource.buildRequest[type](appParams.data))
    }

    if (type === 'GET_LIST')
      return getList(dataProviderBuilder, resource, type, appParams)
    if (type === 'GET_ONE')
      return getOne(dataProviderBuilder, resource, type, appParams)

    return await dataProviderBuilder(
      type,
      resource.hasuraResourceName,
      appParams
    )
  }
}

export default dataProvider
